import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SurroundSoundIcon(props: IconProps) {
    return <Icon {...props} iconKey={"surround_sound"}/>
}
